// extracted by mini-css-extract-plugin
export default {"container":"Text_container__MaLuD","body":"Text_body__WL4U6","tiny":"Text_tiny__QI2R7","bold":"Text_bold__4iM4W","tooltip":"Text_tooltip__MUVYw","large":"Text_large__61goK"};